"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Unassigned_exports = {};
__export(Unassigned_exports, {
  default: () => Unassigned_default
});
module.exports = __toCommonJS(Unassigned_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.36719 9.52734C10.3047 9.52734 11.1055 9.19531 11.7695 8.53125C12.4336 7.86719 12.7656 7.06641 12.7656 6.12891C12.7656 5.20443 12.4336 4.41016 11.7695 3.74609C11.1055 3.08203 10.3047 2.75 9.36719 2.75C8.42969 2.75 7.62891 3.08203 6.96484 3.74609C6.3138 4.41016 5.98828 5.20443 5.98828 6.12891C5.98828 7.06641 6.3138 7.86719 6.96484 8.53125C7.62891 9.19531 8.42969 9.52734 9.36719 9.52734ZM14.3281 10.7969C13.3776 10.7969 12.5573 11.1354 11.8672 11.8125C11.1901 12.4896 10.8516 13.3099 10.8516 14.2734C10.8516 15.237 11.1901 16.0573 11.8672 16.7344C12.5573 17.4115 13.3776 17.75 14.3281 17.75C15.2917 17.75 16.112 17.4115 16.7891 16.7344C17.4661 16.0573 17.8047 15.237 17.8047 14.2734C17.8047 13.3099 17.4661 12.4896 16.7891 11.8125C16.112 11.1354 15.2917 10.7969 14.3281 10.7969ZM14.3281 11.8906C14.5234 11.8906 14.7122 11.9167 14.8945 11.9688C15.0768 12.0078 15.2461 12.0664 15.4023 12.1445L12.3945 15.6406C12.2513 15.4453 12.1406 15.237 12.0625 15.0156C11.9844 14.7812 11.9453 14.5339 11.9453 14.2734C11.9453 13.6224 12.1797 13.0625 12.6484 12.5938C13.1172 12.125 13.6771 11.8906 14.3281 11.8906ZM14.3281 16.6562C14.1328 16.6562 13.9375 16.6302 13.7422 16.5781C13.5599 16.526 13.3841 16.4544 13.2148 16.3633L16.2422 12.8672C16.3854 13.0625 16.4961 13.2839 16.5742 13.5312C16.6654 13.7656 16.7109 14.013 16.7109 14.2734C16.7109 14.9245 16.4766 15.4844 16.0078 15.9531C15.5521 16.4219 14.9922 16.6562 14.3281 16.6562ZM10.5977 11.2852C10.5977 11.2852 10.5911 11.2852 10.5781 11.2852C10.5521 11.2591 10.513 11.2396 10.4609 11.2266C10.4219 11.2005 10.3763 11.1875 10.3242 11.1875H6.88672C6.35286 11.1875 5.84505 11.2852 5.36328 11.4805C4.89453 11.6758 4.48438 11.9427 4.13281 12.2812C3.78125 12.6198 3.50781 13.0169 3.3125 13.4727C3.10417 13.9284 3 14.4102 3 14.918V16.2461C3 16.3763 3.04557 16.487 3.13672 16.5781C3.22786 16.6562 3.33203 16.6953 3.44922 16.6953H9.97266C10.0508 16.6953 10.1224 16.6823 10.1875 16.6562C10.2656 16.6172 10.3242 16.5586 10.3633 16.4805C10.4023 16.4154 10.4219 16.3438 10.4219 16.2656C10.4349 16.1875 10.4284 16.1159 10.4023 16.0508C10.2721 15.7773 10.1745 15.4909 10.1094 15.1914C10.0443 14.8919 10.0117 14.5859 10.0117 14.2734C10.0117 13.8568 10.0703 13.4466 10.1875 13.043C10.3047 12.6393 10.4805 12.2617 10.7148 11.9102C10.793 11.806 10.819 11.6953 10.793 11.5781C10.7669 11.4479 10.7018 11.3503 10.5977 11.2852Z",
      fill: "currentColor"
    }
  )
);
const SvgUnassigned = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Unassigned_default = SvgUnassigned;
